import { dataURItoBlob } from '../dataURItoBlob';

export async function uploadImageToS3(
  image: string | Buffer,
  name: string,
  fileType: string,
  apiRootUrl: string
) {
  const response = await fetch(`${apiRootUrl}/api/images/upload`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ fileName: name, contentType: fileType }),
  });

  if (response.ok) {
    const { url, fields, key } = await response.json();

    const formData = new FormData();
    for (const [key, value] of Object.entries(fields)) {
      formData.append(key, value as string);
    }
    formData.append(
      'file',
      typeof image === 'string' ? dataURItoBlob(image) : new Blob([image])
    );

    const uploadResponse = await fetch(url, {
      method: 'POST',
      body: formData,
    });

    if (uploadResponse.ok) {
      return uploadResponse.url + key;
    }
    console.error('S3 Upload Error:', uploadResponse);
  } else {
    console.error('Failed to get pre-signed URL.');
  }
  return null;
}
